<template>
  <fieldset class="form__options">
    <input
      class="form__checkbox"
      type="checkbox"

      :disabled="disabled"
      :checked="isChecked"
      :id="uniqueId"
      :data-acc="acc.toLowerCase()"
      :value="isChecked"

      @change="onChange"
      @click="onClick"
    />
    <label class="form__toggle form__label tooltip" data-acc="toggle" :for="uniqueId">
      {{ L.localize(label) }}<span class="tooltiptext" v-if="hasTooltip">{{ L.localize(tooltip) }}</span>
    </label>
    <label :for="uniqueId" class="form__options__notice" v-if="notice">{{ L.localize(notice) }}</label>
  </fieldset>
</template>

<script>
import L from 'services/Localization'
import Util from 'services/Util'

export default {
  name: 'checkbox',
  props: {
    label: String,
    tooltip: String,
    notice: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: Boolean,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    acc: {
      type: String,
      required: false,
      default: ''
    },
    submittedValue: {
      type: String,
      default: 'on' // HTML default
    },
    checked: {
      type: Boolean,
      default: false
    },
    trueValue: {
      default: true
    },
    falseValue: {
      default: false
    }
  },
  data() {
    return {
      uniqueId: Util.guid(),
      L: L,
      isChecked: Util.looseEqual(this.value, this.trueValue) || this.checked
    }
  },
  watch: {
    value() {
      this.isChecked = Util.looseEqual(this.value, this.trueValue)
    }
  },
  created() {
    this.$emit('input', this.isChecked ? this.trueValue : this.falseValue)
  },
  methods: {
    onClick(e) {
      this.isChecked = e.target.checked
      this.$emit('input', e.target.checked ? this.trueValue : this.falseValue)
    },
    onChange(e) {
      this.$emit('change', this.isChecked ? this.trueValue : this.falseValue, e)
    }
  },
  computed: {
    hasTooltip() {
      return this.tooltip !== undefined
    }
  }
}
</script >



// WEBPACK FOOTER //
// CheckBox.vue?2aca46f1